import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { businessInfo } from '../data/mock';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  type = 'website'
}) => {
  const location = useLocation();
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://armedguardofficer.com';
  const fullUrl = `${siteUrl}${location.pathname}`;
  const ogImage = image || `${siteUrl}/og-image.jpg`;
  const metaDescription = description || `${businessInfo.name} provides professional armed security services across Florida. Licensed, insured, and ready to protect your business, residential community, or event.`;
  const metaTitle = title ? `${title} | ${businessInfo.name}` : `${businessInfo.name} - Professional Armed Security Services in Florida`;
  const metaKeywords = keywords || 'armed security guards, armed security services, Florida security, Miami security, commercial security, residential security, event security, executive protection, HOA security, licensed security guards';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{metaTitle}</title>
      <meta name="title" content={metaTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content={businessInfo.name} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={businessInfo.name} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional SEO */}
      <meta name="geo.region" content="US-FL" />
      <meta name="geo.placename" content="Miami" />
      <meta name="geo.position" content="25.7617;-80.1918" />
      <meta name="ICBM" content="25.7617, -80.1918" />
      
      {/* Business Information */}
      <meta name="contact" content={businessInfo.email} />
      <meta name="phone" content={businessInfo.phone} />
      <meta name="address" content={businessInfo.address.full} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO;
